import React, { useContext, useState } from "react";

import { QuickLink, QuickReport } from "app/reports";
import { TwoColumnLayout } from "layout/private/components";
import { PrivateContext } from "lib/context";
import { SkeletonList } from "lib/components";

import { PlanCard } from "app/plans";
import { Activity } from "app/userManagement/modules";

import { storageHelper } from "lib/helpers";
import OnBoardingSkeleton from "lib/components/skeletonOnboarding/onBoardingSkeleton";
import { Layout } from "@shopify/polaris";
import { withErrorBoundary } from "lib/hoc";
import OperatorExportReporting from "app/dashboard/modules/provider/export/export";
import appConfig from "configuration";
import constant from "lib/constant/constant";
import dashboardQuickLinks from "./dashboardConfig";

const { brandPageV2URL } = appConfig;
const { providerList } = constant;

const ProviderDashboard = () => {
  const [isExportModal, setIsExportModal] = useState(false);
  const { currentUser, isLoading, cms = {}, vendorHiddenModule, shop } = useContext(PrivateContext);
  const { plan = {} } = currentUser || {};
  const { isStripe = false } = plan || {};
  const isEcommerceUser = !!currentUser.ecommercePlatform;
  const handleShow = () => {
    setIsExportModal(true);
  };

  const onBrandV2Page = () => {
    const url = `${brandPageV2URL}/${providerList.BRAND}/${shop}/${currentUser.brandName}`;
    window.open(url);
  };
  const linkData = dashboardQuickLinks(vendorHiddenModule, isEcommerceUser, cms, handleShow, onBrandV2Page);

  const getSecondaryComponent = () => {
    return (
      <>
        {isStripe && <PlanCard />}
        <QuickLink link={linkData} />
        <QuickReport />
      </>
    );
  };

  const getComponent = () => {
    if (isLoading) {
      return <SkeletonList />;
    }
    return (
      <>
        <Activity />
        <OperatorExportReporting isOpenModal={isExportModal} setIsOpenModal={setIsExportModal} />
      </>
    );
  };

  if (isLoading && storageHelper.get("setupProgress")) {
    return (
      <Layout.Section>
        <OnBoardingSkeleton />
      </Layout.Section>
    );
  }
  return <TwoColumnLayout primary={getComponent()} secondary={getSecondaryComponent()} />;
};

export default withErrorBoundary(ProviderDashboard);
